//------------- COMPONENT ROUNDED BUTTON ---------

//botões "redondos" utilizados por todo o porta

//importações
import React from "react";
import "./styles.css";
import { Link } from "react-router-dom";

//component
//recebe o tipo do <button>, o texto de dentro, o estilo (caso não passe, será adicionado sozinho)
// e o evento que deseja realizar caso o botão não possua tipo
const RoundedButton = ({ type, text, stl = "btn-rounded", event }) => {
    //escolhe o tipo do botão
    const handleType = () => {
        switch (type) {
            //para forms
            case "submit":
                return (
                    <button className={stl} type={type}>
                        {text}
                    </button>
                );
            //para redirecionar
            case "link":
                return (
                    <Link className="btn-link" to={event}>
                        <div className={stl}>{text}</div>
                    </Link>
                );

            //caso queira personalizar o evento de click
            default:
                return (
                    <div className={stl} type={type} onClick={event}>
                        {text}
                    </div>
                );
        }
    };

    //view do component
    return <div className="btn-rounded-div">{handleType()}</div>;
};

export default RoundedButton;
